module.exports = __webpack_public_path__ + "img/staple-icon.5eb18c16.svg";